import Phaser from 'phaser';
import { COLORS, UI, DEPTH } from '../constants';

export interface UITextConfig {
  x: number;
  y: number;
  text: string;
  fontSize?: number;
  color?: number;
  align?: 'left' | 'center' | 'right';
  fontStyle?: string;
}

export class UIText extends Phaser.GameObjects.Text {
  constructor(scene: Phaser.Scene, config: UITextConfig) {
    const fontSize = config.fontSize ?? UI.FONT_SIZE_MEDIUM;
    const colorHex = config.color ?? COLORS.TEXT_WHITE;
    const colorStr = '#' + colorHex.toString(16).padStart(6, '0');

    super(scene, config.x, config.y, config.text, {
      fontSize: `${fontSize}px`,
      color: colorStr,
      fontStyle: config.fontStyle ?? 'normal',
      align: config.align ?? 'center',
    });

    // Set origin based on alignment
    switch (config.align) {
      case 'left':
        this.setOrigin(0, 0.5);
        break;
      case 'right':
        this.setOrigin(1, 0.5);
        break;
      default:
        this.setOrigin(0.5, 0.5);
    }

    this.setDepth(DEPTH.UI_TEXT);
    scene.add.existing(this);
  }

  // Update text with animation
  setTextAnimated(newText: string, duration: number = 200): void {
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      duration: duration / 2,
      onComplete: () => {
        this.setText(newText);
        this.scene.tweens.add({
          targets: this,
          alpha: 1,
          duration: duration / 2,
        });
      },
    });
  }

  // Pulse animation
  pulse(): void {
    this.scene.tweens.add({
      targets: this,
      scale: 1.1,
      duration: 100,
      yoyo: true,
    });
  }
}
